<template>
  <div v-if="validEndDate" class="countdown">
    <div class="countdown__text" v-for="(time, index) in timeRemaining" :key="index">
      <span class="countdown__number">{{time.value}}</span>
      <span> {{ time.key }} </span>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Vue,
  Watch
} from 'vue-property-decorator';
import KeyValue from '../../models/KeyValue';

@Component
export default class CountdownComponent extends Vue {
    @Prop({ default: '' })
    public endDate!: string;

    private currentTime: number = 0;

    private timeDifference: number = 0;

    private interval: any = 0;

    public get remainingSeconds(): number {
      return Math.trunc(this.timeDifference) % 60;
    }

    public get remainingMinutes(): number {
      return Math.trunc(this.timeDifference / 60) % 60;
    }

    public get remainingHours(): number {
      return Math.trunc(this.timeDifference / 60 / 60) % 24;
    }

    public get remainingDays(): number {
      return Math.trunc(this.timeDifference / 60 / 60 / 24);
    }

    public get endTime(): number {
      return Math.trunc(Date.parse(this.endDate) / 1000);
    }

    public formatNumber(number: number): string {
      const numberString = number.toString();
      return (numberString.length < 2) ? `0${numberString}` : numberString;
    }

    public get timeRemaining(): KeyValue[] {
      return [
        new KeyValue('Days', this.formatNumber(this.remainingDays)),
        new KeyValue('Hours', this.formatNumber(this.remainingHours)),
        new KeyValue('Mins', this.formatNumber(this.remainingMinutes)),
        new KeyValue('Secs', this.formatNumber(this.remainingSeconds))
      ];
    }

    @Watch('currentTime')
    public timer() {
      this.timeDifference = this.endTime - this.currentTime;
      if (this.timeDifference <= 0) {
        this.timeDifference = 0;
        clearInterval(this.interval);
      }
    }

    public get validEndDate(): boolean {
      return this.endDate.length > 0;
    }

    public setCurrentTime() {
      this.currentTime = Math.trunc((new Date()).getTime() / 1000);
    }

    public created() {
      if (this.validEndDate) {
        this.interval = setInterval(() => {
          this.setCurrentTime();
        }, 1000);

        this.setCurrentTime();
      }
    }
}
</script>
